<template>
    <div class="filter-group">
        <div
            class="header"
            v-b-toggle="`${title}-filter-options`">
            {{ title }} <i class="fas fa-fw fa-chevron-up"></i>
        </div>
        <b-collapse
            class="filter-options"
            visible
            :id="`${title}-filter-options`">
            <div class="options">
                <b-form-checkbox-group
                    class="apprentice-checkbox"
                    v-model="selected"
                    :options="options.slice(0, 5)"
                    stacked
                    @change="updateFilter"
                    :checked="selected">
                </b-form-checkbox-group>
            </div>
            <div
                class="more"
                v-if="options.length > 5">
                <p
                    class="more-options"
                    v-b-toggle="`${title}-load-more-options`">
                    {{ $t('portfolio.show') }} <span class="closed btn-show-all">{{ $t('common.more') }}</span>
                    <span class="open">{{ $t('portfolio.less') }}</span>
                </p>

                <b-collapse
                    class="load-more-options"
                    :id="`${title}-load-more-options`">
                    <b-form-checkbox-group
                        class="apprentice-checkbox"
                        v-model="selected"
                        :options="options.slice(5)"
                        stacked
                        @change="updateFilter"
                        :checked="selected">
                    </b-form-checkbox-group>
                    <p
                        class="less-options btn-show-less"
                        v-b-toggle="`${title}-load-more-options`">
                        {{ $t('portfolio.show_less') }}
                    </p>
                </b-collapse>
            </div>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: 'design-2021-portfolio-edit-shared-assignments-filter-checkbox-component',
    props: {
        title: String,
        filterKey: String,
        options: Array,
        selectedIn: Array,
        value: Array,
    },
    data() {
        return {
            visible: false,
            selected: this.value,
        };
    },

    methods: {
        updateFilter(checked) {
            this.$emit('update-filter', checked, this.filterKey);
            this.$emit('input', checked);
        },
    },

    watch: {
        value: function (newVal) {
            this.selected = newVal;
        },
    },
};
</script>

<style scoped lang="scss">
.filter-group {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'ten');
        font-weight: $font-weight-medium;
        background-color: $white;
        border-radius: $border-radius-content;
        transition: all 3ms ease;

        i {
            font-size: 0.75rem;
            transform-origin: center;
            transition: all 0.8s ease;
        }

        &.collapsed {
            &:hover {
                background-color: $info;
                color: $white;
                cursor: pointer;
            }

            i {
                transform: rotate(180deg);
            }
        }

        &.not-collapsed {
            background-color: $info;
            color: $white;
        }

        &:hover {
            font-weight: $font-weight-bold;
        }
    }

    .filter-options ::v-deep {
        margin-top: map-get($grid-gutter-spacing, 'eight');

        .apprentice-checkbox {
            .custom-checkbox {
                margin-top: map-get($grid-gutter-spacing, 'eight');
                padding-bottom: map-get($grid-gutter-spacing, 'eight');

                &:not(:last-child) {
                    border-bottom: 3px dotted $border-color;
                    margin-bottom: map-get($grid-gutter-spacing, 'eight');
                }

                &:hover {
                    span {
                        font-weight: $font-weight-bold;
                    }
                }
            }

            &:hover {
                span {
                    font-weight: $font-weight-normal;
                }
            }
        }

        .load-more-options {
            .apprentice-checkbox {
                .custom-checkbox {
                    &:first-child {
                        margin-top: 0;
                        border-top: 3px dotted $border-color;
                        padding-top: map-get($grid-gutter-spacing, 'eight');
                    }
                }
            }
        }
    }

    &:first-child {
        margin-top: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.more-options,
.less-options {
    justify-content: flex-end;
    font-size: 0.8125rem;
    color: $primary;
    cursor: pointer;
    display: flex;
    line-height: 1;
    margin-top: 2px;
    margin-bottom: 2px;
}

.more-options > .open,
.more-options > .closed,
.less-options > .open,
.less-options > .closed {
    margin-left: 4px;
}

.more-options.collapsed {
    display: flex;
}

.more-options.collapsed > .open,
.more-options.not-collapsed > .closed,
.more-options:not(.collapsed) .closed,
.more-options.not-collapsed,
.more-options:not(.collapsed) {
    display: none;
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .filter-group:first-child {
        margin-top: 0;
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .filter-group {
        max-width: 70%;
    }
}
</style>
